/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Button = styled.button`
  display: inline-block;
  border: solid 1px transparent;
  ${(p) => p.round && 'border-radius: .25rem;'}
  ${(p) => p.circle && 'border-radius: 50%;'}
  ${(p) => (p.round || p.circle) && 'padding: .25rem;'}

  background-color: ${(p) => p.bgColor || 'inherit'};

  line-height: 1;

  :focus {
    outline: 0;
  }

  :hover {
    background-color: ${(p) => p.hoverBGColor ? p.hoverBGColor : '#0070D2'};
  }
`;

const SVG = styled.svg`
  height: ${(p) => p.size ? p.size : '1rem'};
  width: ${(p) => p.size ? p.size : '1rem'};
  fill: white;
`;

/**
 * Icon Container for Standard SLDS Icons
 */
const StandardIconButton = ({ className, onClick, icon, size, bgColor, hoverBGColor, round, circle, ariaLabel }) => (
  <Button className={className} onClick={onClick} bgColor={bgColor} size={size} round={round} circle={circle} aria-label={ariaLabel}>
    <SVG size={size} bgColor={bgColor} hoverBGColor={hoverBGColor}>
      <use xlinkHref={`/assets/icons/standard-sprite/svg/symbols.svg#${icon}`}></use>
    </SVG>
  </Button>
);

StandardIconButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  ariaLabel: PropTypes.string
};

StandardIconButton.defaultProps = {
  show: true,
};

export default StandardIconButton;
